import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Image from 'next/image';
import { useTranslations } from '@lang';
import visa from '@root/public/static/visa.svg';
import mastercard from '@root/public/static/mastercard.svg';
import americanExpress from '@root/public/static/american-express.svg';

const ItemList = styled.ul`
  display: flex;
  justify-content: flex-end;
  padding: 0;
  margin: 0;
  list-style: none;
  li + li {
    padding-left: 6px;
  }
`;

const Text = styled.span`
  color: #4b4b4b;
`;

const PaymentMethodsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent};
  font-size: 13px;
`;

const PaymentMethods = ({ withLabel = false, justifyContent = 'flex-start' }) => {
  const { t } = useTranslations();

  return (
    <PaymentMethodsWrapper justifyContent={justifyContent}>
      {withLabel && <Text>{t('basket.footerPayments')}</Text>}
      <ItemList>
        <li>
          <Image src={visa} alt="Visa logo" height="33" width="33" />
        </li>
        <li>
          <Image src={mastercard} alt="Mastercard logo" height="33" width="33" />
        </li>
        <li>
          <Image src={americanExpress} alt="American Express logo" height="33" width="33" />
        </li>
      </ItemList>
    </PaymentMethodsWrapper>
  );
};
PaymentMethods.propTypes = {
  withLabel: PropTypes.bool,
  justifyContent: PropTypes.string,
};

export default PaymentMethods;
